module.exports = __webpack_public_path__ + "img/slide02.336de746.png";